<style lang="scss">
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/mixins";
  @use "../../assets/css/design-system/colors";

  div {
    @include colors.utility_classes();
    @include mixins.body2();

    display: flex;
    align-items: center;
    justify-content: flex-start;

    gap: utils.in_rem(12px);
    padding: utils.in_rem(8px) utils.in_rem(12px);
    border-radius: 6px;

    &.fit-content {
      width: fit-content;
    }

    &.information {
      border-left: 4px solid colors.get(systemInformation_100);
      border-radius: 4px 6px 6px 4px;
      @extend .background-color-systemInformation_10;
      @extend .color-systemInformation_100;

      &.no-border-left {
        border-left: none;
        border-radius: 6px;
      }
    }

    &.success {
      border-left: 4px solid colors.get(systemPositive_100);
      border-radius: 4px 6px 6px 4px;
      @extend .background-color-systemPositive_10;
      @extend .color-systemPositive_100;

      &.no-border-left {
        border-left: none;
        border-radius: 6px;
      }
    }

    &.warning {
      border-left: 4px solid colors.get(systemWarning_100);
      border-radius: 4px 6px 6px 4px;
      @extend .background-color-systemWarning_10;
      @extend .color-systemWarning_100;

      &.no-border-left {
        border-left: none;
        border-radius: 6px;
      }
    }

    &.error {
      border-left: 4px solid colors.get(systemError_100);
      border-radius: 4px 6px 6px 4px;
      @extend .background-color-systemError_10;
      @extend .color-systemError_100;

      &.no-border-left {
        border-left: none;
        border-radius: 6px;
      }
    }

    &.ai {
      border-left: 4px solid colors.get(aiIconPurple);
      border-radius: 4px 6px 6px 4px;
      @extend .background-color-aiSurfacePurple;
      @extend .color-aiIconPurple;

      &.no-border-left {
        border-left: none;
        border-radius: 6px;
      }
    }

    > span.link {
      color: colors.get(textGrey);
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }
  }
</style>

<script>
  import Icon from "./Icon.svelte";

  /** @type {"information" | "warning" | "danger" | "success"} */
  export let message = "information";

  export let linkText = "View";
  export let href = "";
  export let leadingIcon = "";

  let cls = "";
  export { cls as class };

  const iconMap = {
    success: "fa-solid fa-check-circle",
    information: "fa-solid fa-info-circle",
    warning: "fa-solid fa-exclamation-circle",
    error: "fa-solid fa-exclamation-circle",
    ai: "fa-solid fa-info-circle",
  };

  // Catch invalid message types
  if (!iconMap[message] && !leadingIcon) {
    console.error(
      `Invalid message type passed to BannerNotification.svelte: ${message}`
    );
  }

  export let style = "";
</script>

<div class="body {cls} {message}" {style}>
  <Icon class={leadingIcon || iconMap[message]} />
  <slot />
  {#if href}
    <span class="link">
      <a {href} target="_blank" rel="noopener noreferrer">{linkText}</a>
    </span>
  {/if}
</div>
